import { googleApiKey } from '../../config';
import { queryStringFromObject } from '../../core/util/string';
import { isEmpty } from '../util/empty';

const STATIC_MAP_API = 'https://maps.googleapis.com/maps/api/staticmap?';
const STATIC_STREET_VIEW_API = 'https://maps.googleapis.com/maps/api/streetview?';

const latLongString = latLong =>
  typeof latLong === 'string' ? latLong : `${latLong.latitude},${latLong.longitude}`;

const buildMapMarkers = ({ latLong, markers, centerMarker, customMarkers }) => {
  const mapMarkers = markers.map(marker => `${marker.latitude},${marker.longitude}`);
  if (centerMarker) {
    mapMarkers.push(latLongString(latLong));
  }

  if (customMarkers && customMarkers.length) {
    customMarkers.forEach(marker => {
      let anchorPoint =
        marker.anchorXCoord && marker.anchorYCoord
          ? `${marker.anchorXCoord},${marker.anchorYCoord}`
          : 'center';

      mapMarkers.push(`anchor:${anchorPoint}|icon:${marker.url}|${latLongString(marker.latLong)}`);
    });
  }

  return mapMarkers;
};

const buildMapUrl = ({
  latLong,
  width,
  height,
  zoom,
  markers,
  centerMarker = true,
  customMarkers = [],
}) => {
  const mapMarkers = buildMapMarkers({
    latLong,
    markers,
    centerMarker,
    customMarkers,
  });
  const mapOptions = {
    center: latLongString(latLong),
    zoom,
    size: `${width}x${height}`,
    maptype: 'roadmap',
    key: googleApiKey,
  };

  if (!isEmpty(mapMarkers)) {
    mapOptions.markers = mapMarkers;
  }

  return `${STATIC_MAP_API}${queryStringFromObject(mapOptions)}`;
};

const buildStreetViewUrl = (addressAttributes, width, height) => {
  const { address, city, state, latLong } = addressAttributes;

  if (isEmpty(latLong)) return null;

  const mapOptions = {
    location: latLongString(latLong),
    size: `${width}x${height}`,
    key: googleApiKey,
  };

  if (address && city && state) {
    mapOptions.location = `${address},${city},${state}`;
  }

  return `${STATIC_STREET_VIEW_API}${queryStringFromObject(mapOptions)}`;
};

export { buildMapUrl, buildStreetViewUrl };
